var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "poiner",
      on: {
        click: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.$emit("goToPreview")
        },
      },
    },
    [
      _c("div", { staticClass: "box sb" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "div",
              { staticClass: "flex-fill line-clamp text-break" },
              [_vm._t("default")],
              2
            ),
          ]),
          _vm.editPermission
            ? _c(
                "div",
                { staticClass: "d-flex align-items-start ml-2" },
                [
                  _c("c-button", {
                    attrs: {
                      size: "iconic",
                      icon: "edit",
                      tooltip: {
                        text: "Редактировать",
                        activeText: "Редактировать",
                      },
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("goToEdit")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }